





































import { defineComponent, reactive, onMounted, computed } from '@vue/composition-api';
import { usePageBase, useComponentBase } from '../../base';
import { Utils } from '../../helpers/utils';
import { isNullOrTodo } from '../../helpers/filters';
import { getStore } from '../../store';
import { useRouter } from '../../router';

const componentName = 'AppVersionSummary';

export default defineComponent({
    props: {},
    name: componentName,

    setup(props, context) {
        const store = getStore(), { router, route } = useRouter();
        const pageBase = usePageBase();
        const componentBase = useComponentBase();

        const state = reactive({
            loaded: false,
            appVersionData: null
        });

        let langAtLoad: string = '';

        const onCreated = () => {
            componentBase.setLoading(true);


            state.appVersionData = store.state.appVersionSummary;
            pageBase.setNavigation((nav) => {
                nav.push({ title: 'Apps', routerTo: { name: 'apps' }});
                nav.push({ title: `${state.appVersionData.name} ${state.appVersionData.platform}`, routerTo: { name: 'app-versions' }});
                nav.push({ title: `Version ${state.appVersionData.version} (Build ${state.appVersionData.build}) - ${lang.value}`});
            });

            state.loaded = true;

            componentBase.setLoading(false);

            langAtLoad = lang.value;
        }

        const lang = computed(() => route.value.params.lang);

        const languageName = computed(() => Utils.getLanguageName(lang.value));

        const subtitle = computed(() => `Version ${state.appVersionData.version} (Build ${state.appVersionData.build}) – ${languageName.value}`)

        const sections = computed(() => {
            var sections = [];

            // If exists at least one key without a section, create a dummy section.
            if (state.appVersionData.keys && state.appVersionData.keys.some(k => k.sectionId == null)) {
                sections.push({
                    id: 0,
                    name: 'No section',
                    shortName: 'no-section',
                    keys: state.appVersionData.keys && state.appVersionData.keys.filter(k => k.sectionId == null),
                    doneCount: state.appVersionData.keys.filter(k =>
                        (k.sectionId == null) && (!isNullOrTodo(k.texts[lang.value || langAtLoad]))).length,
                    keysCount : state.appVersionData.keys.filter(k => k.sectionId == null).length
                })
            }

            if (state.appVersionData.sections) {
                for (let s of state.appVersionData.sections) {
                    sections.push({
                        id: s.id,
                        name: s.name,
                        shortName: s.shortName,
                        keys: state.appVersionData.keys && state.appVersionData.keys.filter(k => k.sectionId == s.id),
                        doneCount: state.appVersionData.keys && state.appVersionData.keys.filter(k =>
                            (k.sectionId == s.id) && (!isNullOrTodo(k.texts[lang.value || langAtLoad]))).length,
                        keysCount : state.appVersionData.keys && state.appVersionData.keys.filter(k => k.sectionId == s.id).length
                    });
                }
            }

            return sections;
        });

        const percentage = (done: number, total: number) => (total == 0) ? 100 : Math.floor(((done / total) * 100));

        const completionColor = (percentage: number) => Utils.getCompletionColor(percentage);

        const platformIconClass = (platform: string) => Utils.iconPlatformClass('icon', platform);

        onCreated();

        return {
            state,
            languageName,
            sections,
            percentage,
            completionColor,
            platformIconClass,
            lang,
            subtitle
        }
    }
})

